import { defineStore } from 'pinia';

interface SessionInterface {
  email: string,
  token: string,
  temporaryToken: string,
  validationTokenSentAt: Date | null,
  isHttpOnlySession: boolean,
}

const TIME_TO_RESEND_TOKEN = 5 * 60 * 1000;

export const useSessionStore = defineStore({
  id: 'session',
  persist: {
    storage: sessionStorage,
  },
  state: (): SessionInterface => ({
    email: '',
    token: '',
    temporaryToken: '',
    validationTokenSentAt: null,
    isHttpOnlySession: false,
  }),
  getters: {
    hasSession: (state) => {
      if (state.email && state.token) return true;
      if (state.email && state.isHttpOnlySession) return true;
      return false;
    },
    hasTemporarySession: (state) => !!(state.email && state.temporaryToken),
    getTimeToResendToken: (state) => {
      if (!state.validationTokenSentAt) {
        return 0;
      }

      return Math.floor(Math.max(0, (( new Date(state.validationTokenSentAt).getTime() + TIME_TO_RESEND_TOKEN) - Date.now()) / 1000));
    },
  },
  actions: {
    createSession({ email, token }: { email: string; token: string; temporaryToken?: string; validationTokenSentAt?: Date | null }) {
      this.email = email;
      this.token = token;
      this.temporaryToken = '';
      this.validationTokenSentAt = null;
      this.isHttpOnlySession = false;
    },
    
    createHttpOnlySession(email: string) {
      this.email = email;
      this.token = '';
      this.temporaryToken = '';
      this.validationTokenSentAt = null;
      this.isHttpOnlySession = true;
    },
    
    destroySession() {
      this.$reset();
    },
    
    setValidationTokenSentAt(validationTokenSentAt: Date) {
      this.validationTokenSentAt = validationTokenSentAt;
    },
    
    createTemporarySession({ email, temporaryToken, validationTokenSentAt }: { email: string; temporaryToken: string; validationTokenSentAt: Date | null }) {
      this.email = email;
      this.temporaryToken = temporaryToken;
      this.validationTokenSentAt = validationTokenSentAt;
      this.isHttpOnlySession = false;
    },
  },
});
